import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createSelector } from 'reselect';
const getDarkMode = basicSelector(state => state.darkMode);
export const getIsEditorDarkModeEnabled = createSelector([getDarkMode], darkMode => darkMode.isEditorDarkModeEnabled);